import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyThuChiHopDongApi from "../../../../service/quanLyThuChiHopDongApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { useSelector, useDispatch } from "react-redux";
// import {
//   getListQuanLyThuChiNgoaiLe,
//   updateDataSearch,
// } from "../../../../../actions/QuanLyThuChiNgoaiLe";
import {
  getListQuanLyThuChiHopDong,
  updateDataSearch,
} from "../../../../actions/QuanLyThuChiHopDong";
import { currentDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import userApi from "../../../../service/userApi";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import CuaHangDoiTacApi from "../../../../service/cuaHangDoiTacApi";
import CauHinhApi from "service/cauHinhApi";
export const SuaThuChiHopDong = (props) => {
  //Code
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiHopDong,
  );
  const dispatch = useDispatch();

  const [isActiveSubmit, setIsActiveSubmit] = useState(false);
  const [dataThuChi, setDataThuChi] = useState(props.ThuChi);
  // Danh sách trả HinhThucThanhToan đã quy NULL về 0 (Tiền mặt)
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState(
    props.ThuChi.HinhThucThanhToan === 1 ? "1" : "0",
  );

  //Thông báo
  const validateName = (nguoinop) => {
    const expression = /(\w.).+/i;
    return expression.test(String(nguoinop).toLowerCase());
  };

  const initErrors1 = { ngaythanhtoan: "" };
  const [errors1, setErrors1] = useState(initErrors1);

  const initErrors2 = { nguoithanhtoan: "" };
  const [errors2, setErrors2] = useState(initErrors2);

  const initErrors3 = { ghichu: "" };
  const [errors3, setErrors3] = useState(initErrors3);
  const [isLoading, setIsLoading] = useState(true);
  const initNguonKhachHang = {
    listNguonKhachHang: [
      {
        label: "Tất cả",
        value: 0,
      },
    ],
  };
  const [nguonkhachhang, setNgonKhachHang] = useState(
    initNguonKhachHang.listNguonKhachHang,
  );
  const [isTongThuCaPhiVaLai, setTongThuCaPhiVaLai] = useState(false);
  const updateDropdown = (field) => (e) => {
    setDataThuChi({
      ...dataThuChi,
      [field]: e.target.value,
    });
  };

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataThuChi({
      ...dataThuChi,
      [field]: e.target.value,
    });

    if (field === "Name" && dataThuChi.Name === "") {
      setErrors2({
        ...errors2,
        nguoithanhtoan: "Nhập tên người thanh toán",
      });
    } else {
      setErrors2({
        ...errors2,
        nguoithanhtoan: "",
      });
    }
  };

  const onChangeNumber = (field) => (evt) => {
    setDataThuChi({
      ...dataThuChi,
      [field]: convertToNumber(evt.target.value),
    });
    if (evt.target.value === "") {
      setErrors2({
        ...errors2,
        sotien: "Nhập tiền",
      });
    } else if (evt.target.value === 0) {
      setErrors2({
        ...errors2,
        sotien: "Nhập tiền",
      });
    } else {
      setErrors2({
        ...errors2,
        sotien: "",
      });
    }
  };

  const onChangeDate = (field) => (evt) => {
    setDataThuChi({
      ...dataThuChi,
      [field]: formatDayMonth(evt),
    });
    if (evt === "null" || evt === "") {
      setErrors1({
        ...errors1,
        ngaythanhtoan: "Nhập ngày thanh toán",
      });
    } else {
      setErrors1({
        ...errors1,
        ngaythanhtoan: "",
      });
    }
  };

  useEffect(() => {
    CuaHangDoiTacApi.combo().then((response) => {
      const dataComDoiTac = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setNgonKhachHang(dataComDoiTac);
    });
    if (isLoading) {
      CauHinhApi.getConfigSys1().then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const cauHinhTongThuCaPhiVaLai = response.data.find(
              (e) => e.keyConfig.toUpperCase() === "TONGTHUCAPHIVALAI",
            );
            if (cauHinhTongThuCaPhiVaLai) {
              if (cauHinhTongThuCaPhiVaLai.valueConfig == "1")
                setTongThuCaPhiVaLai(true);
            }
          }
        }
      });
      setIsLoading(false);
    }
  }, []);

  const onSubmit = () => {
    if (dataThuChi.Time === "") {
      setErrors1({
        ...errors1,
        ngaythanhtoan: "Nhập ngày thanh toán",
      });
      return;
    }
    if (dataThuChi.Name === "") {
      setErrors2({
        ...errors2,
        nguoithanhtoan: "Nhập tên người thanh toán",
      });
      return;
    }

    setIsActiveSubmit(true);
    QuanLyThuChiHopDongApi.editThuNgoaiHopDong1(
      dataThuChi.ThuChiID,
      dataThuChi.Time,
      dataThuChi.Name,
      dataThuChi.Value,
      dataThuChi.PhiKho,
      dataThuChi.OtherFee,
      dataThuChi.PhiPhatDongLai,
      dataThuChi.Note,
      dataThuChi.ShopDoiTacId,
      props.batHinhThucThanhToan ? Number(hinhThucThanhToan) : null,
    ).then((response) => {
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
        setIsActiveSubmit(false);
        return;
      } else {
        // showAlert();
        pushNotification(response.data.Message, "success", "TOP_CENTER", 1000);
        props.onHide();
        dispatch(getListQuanLyThuChiHopDong(dataSearch));
      }
      setIsActiveSubmit(false);
    });
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i class="mdi mdi-pencil-circle"></i>
          </span>{" "}
          Sửa phiếu thu hợp đồng
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse53"
                className="card-header border-info"
                href="#collapse53"
                aria-expanded="true"
                aria-controls="collapse53"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Thay đổi giao dịch</h3>
                </a>
              </div>
              <div
                id="collapse53"
                aria-labelledby="headingCollapse53"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Mã hợp đồng</label>
                          <input
                            type="text"
                            className="form-control input-sm text-era"
                            value={dataThuChi.Code}
                            readOnly={true}
                          ></input>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Ngày tạo</label>
                          <DateTimePicker
                            value={convertDate(dataThuChi.CreatedTime)}
                            name="CreatedTime"
                            readOnly={true}
                          ></DateTimePicker>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Ngày thanh toán</label>
                          <DateTimePicker
                            value={convertDate(dataThuChi.Time)}
                            name="Time"
                            onChange={onChangeDate("Time")}
                            maxDate={new Date()}
                          ></DateTimePicker>
                          {errors1.ngaythanhtoan && (
                            <span className="canh-bao-red">
                              {errors1.ngaythanhtoan}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Người thanh toán</label>
                          <input
                            type="text"
                            className="form-control input-sm text-era"
                            value={dataThuChi.Name}
                            onChange={updateTextValue("Name")}
                          ></input>
                          {errors2.nguoithanhtoan && (
                            <span className="canh-bao-red">
                              {errors2.nguoithanhtoan}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Tiền thanh toán</label>
                          {isTongThuCaPhiVaLai && (
                            <input
                              type="text"
                              className="form-control input-sm text-era"
                              value={formatNumber(dataThuChi.Value)}
                              onChange={onChangeNumber("Value")}
                            ></input>
                          )}{" "}
                          {!isTongThuCaPhiVaLai && (
                            <input
                              type="text"
                              className="form-control input-sm text-era"
                              value={formatNumber(dataThuChi.Value)}
                              onChange={onChangeNumber("Value")}
                            ></input>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Phí khác</label>
                          <input
                            type="text"
                            className="form-control input-sm text-era"
                            value={formatNumber(dataThuChi.OtherFee)}
                            onChange={onChangeNumber("OtherFee")}
                          ></input>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Phí kho</label>
                          <input
                            type="text"
                            className="form-control input-sm text-era"
                            value={formatNumber(dataThuChi.PhiKho)}
                            onChange={onChangeNumber("PhiKho")}
                          ></input>
                        </div>
                      </div>
                      {props.isDuDungPhiPhatDongLaiTatToan && (
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Phạt chậm đóng lãi</label>
                            <input
                              type="text"
                              className="form-control input-sm text-era"
                              value={formatNumber(dataThuChi.PhiPhatDongLai)}
                              onChange={onChangeNumber("PhiPhatDongLai")}
                            ></input>
                          </div>
                        </div>
                      )}

                      {props.isHoaHongTraGop && (
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Kênh thanh toán</label>

                            <select
                              name="kenhthanhtoan"
                              className="selectBox form-control input-sm"
                              value={dataThuChi.ShopDoiTacId}
                              onChange={updateDropdown("ShopDoiTacId")}
                            >
                              {nguonkhachhang &&
                                nguonkhachhang.map((item, idx) => (
                                  <option
                                    key={"objComboStore1" + idx}
                                    value={item.value}
                                  >
                                    {item.label}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      )}
                      {props.batHinhThucThanhToan && (
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Hình thức thanh toán</label>
                            <select
                              name="hinhthucthanhtoan"
                              className="selectBox form-control input-sm"
                              value={hinhThucThanhToan}
                              onChange={(e) =>
                                setHinhThucThanhToan(e.target.value)
                              }
                            >
                              <option value="0">Tiền mặt</option>
                              <option value="1">Chuyển khoản</option>
                            </select>
                          </div>
                        </div>
                      )}
                      <div className="col-md-8">
                        <div className="form-group">
                          <label>Ghi chú</label>
                          <textarea
                            rows="1"
                            className="form-control input-sm text-era"
                            name="comment"
                            placeholder="Ghi chú"
                            value={dataThuChi.Note}
                            onChange={updateTextValue("Note")}
                          ></textarea>
                          {errors3.ghichu && (
                            <span className="canh-bao-red">
                              {errors3.ghichu}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        {isActiveSubmit == false && (
          <>
            <a
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={onSubmit}
            >
              <span className="btn-icon-left">
                <i class="mdi mdi-check"></i>
              </span>{" "}
              Xác nhận
            </a>
          </>
        )}
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
